export const rangeMap = {
    RANGE_1_3: "1-3",
    RANGE_4_10: "4-10",
    RANGE_11_20: "11-20",
    RANGE_21_50: "21-50",
    RANGE_GREATER_THAN_20: ">20",
} as const;
